import { createFeature, createReducer, on } from '@ngrx/store';
import { UserAccountModel } from '@shared/data-access/models';
import { UserAccountAction } from '../actions';

export const featureName = 'userAccount';

export interface DataState {
  detail: UserAccountModel | null;
}
export const initialState: DataState = {
  detail: null,
};
export const userAccountFeature = createFeature({
  name: featureName,
  reducer: createReducer(
    initialState,
    on(UserAccountAction.getDetail, (state, prop: { item: UserAccountModel }) => ({ ...state, detail: prop.item }))
  ),
});

export const {
  name, // feature name
  reducer, // feature reducer
} = userAccountFeature;
